/// <amd-module name="Wit/Common/Utilities/TempQueryUtils" />
import { IVssPageContext } from "VSS/Platform/Context";
import { getTemporaryDataClient } from "Wit/Clients/TemporaryData/RestClient/TemporaryData";
import { TemporaryDataCreatedDTO, TemporaryDataDTO } from "Wit/Clients/TemporaryData/Contracts/TemporaryData";
import { ITemporaryQueryData } from "Wit/Clients/TemporaryData/Contracts/TemporaryDataModel";
import { newGuid } from "VSS/Core/Util/String";

export namespace TempQueryUtils {
    export interface ITempQuery {
        queryText: string;
        queryType: number;
    }

    /**
     * Creates a temp query with the given WIQL and returns a promise with temp query id.
     * @param pageContext Page context
     * @param projectName Project name
     * @param queryText WIQL query
     * @returns A promise containing the query ID
     */
    export function beginCreateTemporaryQueryId(pageContext: IVssPageContext, queryText: string, queryType?: number): Promise<string> {
        const temporaryRestClient = getTemporaryDataClient(pageContext);
        const idGuid: string = newGuid();

        const temporaryQueryData = { queryText: queryText, queryType: queryType } as ITemporaryQueryData;
        return temporaryRestClient
            .createTemporaryData({ value: temporaryQueryData } as TemporaryDataDTO, idGuid)
            .then((response: TemporaryDataCreatedDTO) => response.id);
    }

    export function getTemporaryQuery(pageContext: IVssPageContext, id: string): Promise<ITempQuery> {
        const temporaryRestClient = getTemporaryDataClient(pageContext);
        return temporaryRestClient.getTemporaryData(id).then((response: TemporaryDataCreatedDTO) => {
            return response.value;
        });
    }
}
